var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export const Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-c4hs1b-0"
})(["padding:6px 3px;cursor:pointer;color:", ";user-select:none;&:not(:last-child){margin-right:9px;}svg{margin-left:4px;vertical-align:middle;}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.primaryLL;
});
export const LinkLabel = styled.a.withConfig({
  displayName: "partials__LinkLabel",
  componentId: "sc-c4hs1b-1"
})(["display:block;padding:4px 0;color:", ";&:hover{color:#fff;}", " > span{position:relative;}"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.primaryLL;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    svg {\n      display: none;\n    }\n  "]))));
export const HighlightDot = styled.span.withConfig({
  displayName: "partials__HighlightDot",
  componentId: "sc-c4hs1b-2"
})(["position:absolute;background-color:", ";border-radius:50%;width:5px;height:5px;margin-top:2px;"], _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.secondary;
});